import React from "react";
import { CCard, CCardBody, CCardHeader } from "@coreui/react";

const CancellationAndRefund = () => {
  return (
    <div className="privacy-page">
      <CCard className="privacy-card">
        <CCardHeader className="privacy-header">
          <h2>Cancellation &amp; Refund</h2>
        </CCardHeader>

        <CCardBody className="privacy-body">
          <p>
            We have a 30-day return policy, which means you have 30 days after
            receiving your item to request a return.
          </p>

          <p>
            To be eligible for a return, your item must be in the same condition
            that you received it, unworn or unused, with tags, and in its
            original packaging. You&apos;ll also need the receipt or proof of
            purchase.
          </p>

          <p>
            To start a return, you can contact us at{" "}
            <strong>care@ezybuy.app</strong>. Please note that returns will need
            to be sent to the following address:
          </p>

          <p>
            SCO – 193-194-195, 3rd Floor, Sector – 34 A, Chandigarh -160022,
            Chandigarh, CH, 160022, India
          </p>

          <p>
            If your return is accepted, we’ll send you a return shipping label,
            as well as instructions on how and where to send your package. Items
            sent back to us without first requesting a return will not be
            accepted.
          </p>

          <p>
            Please note that if your country of residence is not India, shipping
            your goods may take longer than expected.
          </p>

          <p>
            You can always contact us for any return questions at{" "}
            <strong>care@ezybuy.app</strong>.
          </p>

          <h4>Damages and Issues</h4>
          <p>
            Please inspect your order upon receipt and contact us immediately if
            the item is defective, damaged, or if you receive the wrong item, so
            that we may evaluate the issue and make it right.
          </p>

          <p>
            Certain types of items cannot be returned, like perishable goods
            (such as food, flowers, or plants), custom products (such as special
            orders or personalized items), and personal care goods (such as
            beauty products).
          </p>

          <p>
            We also do not accept returns for hazardous materials, flammable
            liquids, or gases. Please get in touch if you have questions or
            concerns about your specific item.
          </p>

          <p>
            Unfortunately, we cannot accept returns on sale items or gift cards.
          </p>

          <h4>Exchanges</h4>
          <p>
            The fastest way to ensure you get what you want is to return the
            item you have, and once the return is accepted, make a separate
            purchase for the new item.
          </p>

          <h4>Refunds</h4>
          <p>
            We will notify you once we’ve received and inspected your return to
            let you know if the refund was approved or not. If approved, you’ll
            be automatically refunded on your original payment method within 10
            business days.
          </p>

          <p>
            Please remember it can take some time for your bank or credit card
            company to process and post the refund too.
          </p>

          <p>
            If more than 15 business days have passed since we’ve approved your
            return, please contact us at <strong>care@ezybuy.app</strong>.
          </p>
        </CCardBody>
      </CCard>
    </div>
  );
};

export default CancellationAndRefund;
